import { DataTableLoaderLayout } from './index';

export const DATA_TABLE_DEFAULT_LOADER_LAYOUT: DataTableLoaderLayout = {
  rows: 5,
  columns: 5,
};

export const ROW_EDIT_MODE = 'row-edit-mode';
